'use client';

import dynamic from 'next/dynamic';

const PhotoGalleryInteractive = dynamic(
  () => import('./PhotoGalleryInteractive'),
  { ssr: false, loading: () => (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  )}
);

export default function PhotoGalleryClient() {
  return <PhotoGalleryInteractive />;
}
